import { render, staticRenderFns } from "./obatmasuk.vue?vue&type=template&id=3b1331ff&"
import script from "./obatmasuk.vue?vue&type=script&lang=js&"
export * from "./obatmasuk.vue?vue&type=script&lang=js&"
import style0 from "./obatmasuk.vue?vue&type=style&index=0&id=3b1331ff&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports